/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect } from 'react'
import QRCode from 'react-qr-code'
import { getDataTicket } from '../../service/callAPI'

import { Box, Container, Link, Paper, Typography, Button, Grid } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import LoadingThankyou from '../../components/LoadingThankyou'

function Reject() {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('sm'))
  return (
    <div>
      <Box sx={{ backgroundColor: '#15261e' }}>
        <img src={window.location.origin + '/Main_Banner.jpg'} width="100%" alt="logo" />
      </Box>
      <Box sx={{ pl: '20px', pr: '20px', textAlign: 'center', backgroundColor: '#15261e' }}>
        <Box sx={{ pb: 2, pt: 2 }}>
          <Typography
            variant="h3"
            sx={{
              color: '#ffffff',
              fontSize: matches ? '1.95rem' : '1.38rem',
            }}
          >
            Thank you for your interest in <br /> State of HR Summit 2023!
          </Typography>
        </Box>
        <Box sx={{ pb: '40px' }}>
          <Typography
            variant="h6"
            sx={{
              color: '#ffffff',
            }}
          >
            It looks like the slots for the event are all booked. Thank you for your understanding
            and we would like to apologize for the inconvenience caused by this. We hope to see you
            soon at our other events.
          </Typography>
        </Box>
      </Box>
      <Box sx={{ pl: '20px', pr: '20px', textAlign: 'center' }}>
        <Box sx={{ pb: 2, pt: 2 }}>
          <Typography
            variant="h3"
            sx={{
              color: '#15261e',
              fontSize: matches ? '1.95rem' : '1.38rem',
            }}
          >
            For questions, please reply to reply to this email or check out <br /> the State of HR
            Summit 2023 Website below:
          </Typography>
        </Box>
        <Box sx={{ pt: '20px', pb: '40px' }}>
          <Button
            component="a"
            href="https://events.sprout.ph/the-state-of-hr-2023"
            target="_blank"
            sx={{
              fontSize: matches && '1.175rem',
              // fontSize: '1.175rem',
              color: '#15261E',
              backgroundColor: '#e0c651',
              '&:hover': {
                color: '#15261E',
                backgroundColor: '#e0c651',
              },
            }}
          >
            Visit the State of HR Summit 2023 Website
          </Button>
        </Box>
      </Box>
      <Box sx={{ pl: '20px', pr: '20px', textAlign: 'center', backgroundColor: '#15261e' }}>
        <Box sx={{ pb: 2, pt: 2 }}>
          <Typography
            variant="p"
            sx={{
              color: '#ffffff',
            }}
          >
            Sprout Solutions, 9th floor Unit D, Rockwell Business Center Sheridan North Tower,
            Sheridan St. cor United St., <br /> Mandaluyong City, Metro Manila 1554, Philippines,
            02-3485-8338 / 02-8779-6542
          </Typography>
        </Box>
      </Box>
      <Box sx={{ backgroundColor: '#15261e' }}>
        <img src={window.location.origin + '/Sponsor_logos.png'} width="100%" alt="logo" />
      </Box>
    </div>
  )
}

export default Reject
